export default "__VITE_ASSET__Dmr1lJC5__"